<template>
    <div class="acountStatus"> 
        <div class="mainTitle text-center my-3">
            <h3 class="mb-4">{{$t('depTransHist')}}</h3>
			<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
            <message-component :message="response_msg" :messageType="msg_type"></message-component>
        </div>
        <div class="radius pt-3"> 
            <div class="inMiddle-area"> 

                <!-- transaction history -->
                <div class="timeLineHistory position-relative" >
                  <ul class="mainList-deposit" v-if="(!pageLoader && trans_hitory != '' && trans_hitory.length > 0)">
                  	<li class="leftArea-element mb-3" v-for="list in trans_hitory"> 
                  	 <span class="dotCircle"></span>
                  	  <span class="mainTP-circle"> 
                  	   <span class="historyDeposit d-flex" :class="(parseInt(list.status) == 1)?'complete':''">
                  	  	<span class="historyList-icon">
                  	  	 <img :src="'../../../../static/fxView/images/'+currency[list.currency.toUpperCase()]" class="data_currency">
                  	  	</span>
                  	  	<ul class="historyList">
                  	  	  <li>
                  	  	  	<span class="blockID">
                  	     	 <span class="tI">{{$t('accountId')}}</span>
                  	     	 <span class="tL">{{list.trading_account_id}}</span>
                  	        </span>
                  	        <span class="priceID">
                  	         {{currencyIcon[list.currency]}} {{list.amount}}
                  	        </span>
                  	     </li>
                  	      <li>
                  	  	  	<span class="blockID">
                  	     	 <span class="tI">{{$t('transId')}}</span>
                  	     	 <span class="tL">{{list.transactionId}} </span>
                  	        </span>
                  	        <span class="blockID">
                  	     	 <span class="tI">{{$t('payMeth')}}</span>
                  	     	 <span class="tL">{{depositMethod[list.method]}}</span>
                  	        </span>
                  	     </li>
                  	     <li>
                  	  	  	<span class="blockID">
                  	     	 <span class="date">{{list.created | moment("DD MMMM YYYY")}}<!--  <span class="time">01:48:12</span> --></span>
                  	     	 
                  	        </span>
                  	        <span class="blockID">
                  	     	 <span class="alert" :class="badgeColor[list.status]">{{paymentStatus[list.status]}}</span>
                  	        </span>
                  	     </li>
                         <li> 
                          <router-link :to="{name: 'fxView.support', params: {tabName:'openRequest'}}"   title="View" data-placement="top" class="bdMore btn_xs grd_btn d-flex align-items-center"  data-toggle="tooltip" v-if="parseInt(list.status) == 4">
                            <feather type="eye"></feather> {{$t('clickToResolve')}}
                          </router-link>
                          <p v-else>-</p>
                         </li>
                  	    </ul>
                  	   </span>
                  	 </span>
                  	</li>
                  	<!-- <li class="rightArea-element"> 
                  	 <span class="dotCircle"></span>
                  	  <span class="mainTP-circle"> 
                  	   <span class="historyDeposit d-flex">
                  	  	<span class="historyList-icon">
                  	  	 icon
                  	  	</span>
                  	  	<ul class="historyList">
                  	  	  <li>
                  	  	  	<span class="blockID">
                  	     	 <span class="tI">Account ID</span>
                  	     	 <span class="tL">8138185</span>
                  	        </span>
                  	        <span class="priceID">
                  	         $200.00
                  	        </span>
                  	     </li>
                  	      <li>
                  	  	  	<span class="blockID">
                  	     	 <span class="tI">Transaction Id</span>
                  	     	 <span class="tL">8138185</span>
                  	        </span>
                  	        <span class="blockID">
                  	     	 <span class="tI">Payment Method</span>
                  	     	 <span class="tL">Neteller</span>
                  	        </span>
                  	     </li>
                  	     <li>
                  	  	  	<span class="blockID">
                  	     	 <span class="date">11 July 2020 <span class="time">01:48:12</span></span>
                  	        </span>
                  	        <span class="blockID">
                  	     	 <span class="alert alert-danger">Transaction Initiated</span>
                  	        </span>
                  	     </li>
                  	    </ul>
                  	   </span>
                  	 </span>
                  	</li> -->
                  	 
                  </ul>	
                   <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="col_span" :list="trans_hitory" v-else></loader-component>
                </div>
            </div>
        </div>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    export default {
        name: 'DEPOSIT-TRANSACTION',
        mixins: [fxViewMixins],
        data() {
            return {
                //===========prop in loader component=======
                col_span : 8,
				        trans_hitory : [],
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,

                //==========================================
                pageLimit : '15',
                search : '',
                page : '1', 
				currencyIcon :{'EUR' : '€','USD' : '$','GBP' : '£','CHF' : 'CHF','JPY' : '¥','AUD': '$'},
                badgeColor: {"-1":"alert-info", "0": "alert-warning", "1": "alert-success", "2":"alert-danger", "3":"alert-danger", "4": "alert-danger"}
            }
        },
        methods:{
            listing(){
                let inputJson = {
                    'globalParams' : {
                        transaction_id  :  this.$route.query.id
                    } ,'localParams' : {'parameter' : this}
                }
                this._runGetTransactionStatus(inputJson)
            }
        },
        created(){
            this.listing()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/deposit/deposit_transaction.vue